/****************************************************
 * Module Name:  userBifurcationPieChart.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { useState } from "react";
import DashboardProxy from "../../utility/proxy/manager/dashboardProxy";
import Constants from "../../utility/constants";
import { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import UserModal from "./userModal";
import CommonSnackbar from "../common/commonSnackBar";
import Utility from "../../utility/utility";
import { FaUser } from "react-icons/fa";

let useColor = Utility.GetRandomColorForPieChart();

const UserBifurcationPieChart = () => {
  const [chartData, setChartData] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [show, setShow] = useState(false);
  const [userType, setUserType] = useState("");

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    handleSearch();
  }, []);

  const handleLegends = (value, entry) => {
    return Constants.USER_TYPE[entry.payload.usertype];
  };

  const handleSearch = () => {
    DashboardProxy.GetAllUsersCount((response) => {
      if (response) {
        setChartData(response);
      } else {
        setErrorSnackbar(true);
      }
    });
  };

  function CustomTooltip({ payload, label, active }) {
    if (active) {
      return (
        <Box bgcolor={"#FFFFF7"} padding={2} sx={{ opacity: 0.8 }}>
          <Typography>
            {Constants.USER_TYPE[payload[0].payload.usertype]} <br />
            Count :{payload[0].value}
          </Typography>
        </Box>
      );
    }

    return null;
  }

  const handleModalOpen = (e) => {
    setShow(true);
    setUserType(e.payload.usertype);
  };

  return (
    <div>
      <CommonSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />
      <UserModal
        show={show}
        userType={userType}
        handleClose={() => setShow(false)}
      />
      <Paper elevation={4}>
        <Card>
          <CardHeader
            avatar={<FaUser size={25} color={useColor[1 % useColor.length]} />}
            title={
              <Typography
                component="span"
                fontWeight={Constants.defaultFontWeight}
                fontSize={"1.25rem"}
              >
                User Bifurcation
              </Typography>
            }
            subheader="No. of system users by user type"
          />
          <CardContent>
            <Box height={matches ? 300 : 500} width={matches ? 320 : 550}>
              <ResponsiveContainer width="99%">
                <PieChart>
                  <Pie
                    data={chartData}
                    labelLine={true}
                    label
                    fill="#8884d8"
                    dataKey="count"
                    onClick={(e) => handleModalOpen(e)}
                    stroke="#000000"
                    strokeWidth={1}
                  >
                    {chartData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={useColor[index % useColor.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                  <Legend formatter={handleLegends} />
                </PieChart>
              </ResponsiveContainer>
            </Box>
          </CardContent>
        </Card>
      </Paper>
    </div>
  );
};

export default UserBifurcationPieChart;
